import { LegalLayout } from "@/components/LegalLayout";
import { ShieldCheck } from "lucide-react";

const sections = [
  { heading: "Seller verification", body: (
    <p>Every seller undergoes identity and business verification (KYC) before their store goes live. We review uploaded documents and may request additional evidence at any time.</p>
  ) },
  { heading: "Product safety & authenticity", body: (
    <p>Listings must be accurate, safe and lawful. Counterfeit, recalled, prohibited or unsafe products are strictly forbidden and removed on detection.</p>
  ) },
  { heading: "Anti-fraud & anti-money-laundering", body: (
    <p>We monitor transactions for fraud, chargeback abuse and suspicious activity. Payouts are subject to review, and we cooperate with payment partners and authorities where required.</p>
  ) },
  { heading: "Fair marketplace conduct", body: (
    <p>Manipulating reviews, price gouging, deceptive advertising and harassment breach our policies. Violations can lead to warnings, listing removal, withheld payouts or account suspension.</p>
  ) },
  { heading: "Data protection", body: (
    <p>We process personal data lawfully and securely under the EU GDPR and Nigeria's Data Protection Act (NDPA/NDPR). See our <a className="text-primary underline underline-offset-2" href="/privacy">Privacy Policy</a> for details.</p>
  ) },
  { heading: "Consumer protection", body: (
    <p>We uphold consumer rights under the EU Consumer Rights Directive and Nigeria's Federal Competition and Consumer Protection Act (FCCPA), including safe products, honest listings and fair redress. See our <a className="text-primary underline underline-offset-2" href="/return-refund-policy">Return &amp; Refund Policy</a>.</p>
  ) },
  { heading: "Report a concern", body: (
    <p>Suspect a violation? Tell us through <a className="text-primary underline underline-offset-2" href="/disputes">Disputes & Reports</a>. Genuine reports are handled confidentially.</p>
  ) },
];

export default function IntegrityCompliance() {
  return (
    <LegalLayout
      title="Integrity & Compliance"
      icon={ShieldCheck}
      testid="integrity-compliance-page"
      intro="Trust is the foundation of Xurray Mart. Our Integrity & Compliance programme protects buyers, sellers and the wider community through clear standards and rigorous enforcement."
      sections={sections}
    />
  );
}
